import { Close, FilterListOutlined } from "@mui/icons-material";
import { Box, Divider, FormControl, Typography, useTheme } from "@mui/material";
import { DropdownFilter } from "@pimo/pimo-components";
import { OverviewFilterData, OverviewFilterOptions } from "aint-types";
import { FC } from "react";

export interface OEOverviewFilterDialogProps {
  onClick?: () => void;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    trigger: string
  ) => void;
  filterData: OverviewFilterData;
  filterOptions: OverviewFilterOptions;
}

export const OEOverviewFilterDialog: FC<OEOverviewFilterDialogProps> = ({
  onClick,
  handleChange,
  filterData,
  filterOptions,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 1,
        gap: 0,
        width: 300,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
            width: "100%",
            pr: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              pr: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "start",
                width: "100%",
              }}
            >
              <FilterListOutlined />
              <Typography sx={{ fontWeight: 500 }}>Filter</Typography>
            </Box>
            <Close onClick={onClick} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, py: 2 }}>
            <FormControl
              component="fieldset"
              sx={{ display: "flex", flexDirection: "column", gap: 1 }}
            >
              {
                // Only show the OE filter if there are more than one OE projects and if no region filter is selected,
                // which will prevent users who do not have access to multiple OE projects from seeing the filter
              }
              {(filterOptions?.oeName?.length ?? 0) > 1 &&
                (filterData.regionsFilter?.length ?? 0) === 0 && (
                  <DropdownFilter
                    options={filterOptions.oeName ?? []}
                    value={filterData.oeNameFilter}
                    label="OE"
                    handleChange={handleChange}
                    triggerIdentifier={"oeNameFilter"}
                  />
                )}
              {
                // Only show region filter if no oe filter is selected, if there are more than one region.
              }
              {(filterOptions?.regions?.length ?? 0) > 1 &&
                (filterData.oeNameFilter?.length ?? 0) === 0 && (
                  <>
                    <Divider
                      sx={{
                        bgcolor: theme.palette.secondary.main,
                        height: "1px",
                        borderWidth: 0,
                      }}
                    />{" "}
                    <DropdownFilter
                      options={filterOptions.regions ?? []}
                      value={filterData.regionsFilter ?? []}
                      label="Region"
                      handleChange={handleChange}
                      triggerIdentifier={"regionsFilter"}
                    />
                  </>
                )}
            </FormControl>
          </Box>
        </Box>
      </Box>
      <Divider
        sx={{
          bgcolor: theme.palette.secondary.main,
          height: "1px",
          borderWidth: 0,
        }}
      />
    </Box>
  );
};
